import { render, staticRenderFns } from "./GoodsJump.vue?vue&type=template&id=19b26522&scoped=true&"
import script from "./GoodsJump.vue?vue&type=script&lang=js&"
export * from "./GoodsJump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b26522",
  null
  
)

export default component.exports